// Webpack Imports
import * as bootstrap from 'bootstrap';
import LazyLoad from "vanilla-lazyload";
import $ from 'jquery';
window.bootstrap = require('bootstrap');

window.breakpoints = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
};


$.fn.simpleAccordion = function (options) {
    options = $.extend({
        start: 0,
        activeClass: "active",
        itemClass: "accordion-item",
        timing: 5000,
    }, options || {});

    var timing;

    function stopTimeline()
    {
        clearTimeout(timing);
    }

    function startTimeline(last, activeItem)
    {
        timing = setTimeout(function () {
            updateView(last ? activeItem.siblings(':first-child') : activeItem.next());
        }, options.timing)
    }

    function updateView(activeItem)
    {
        var activeItemIndex = activeItem.attr('data-accordion')
        var otherItems = activeItem.siblings();
        var last = activeItem.is(':last-child');

        otherItems.removeClass(options.activeClass).children('dd').slideUp();
        activeItem.addClass(options.activeClass).children('dd').slideDown();

        $('.accordion-timeline .accordion-timeline-item').removeClass('active');
        $('.accordion-timeline .accordion-timeline-item[data-accordion="' + activeItemIndex + '"]').addClass('active');

        startTimeline(last, activeItem);
    }

    $('.accordion-timeline-item').on('click', function (e) {
        var item = $(this).attr('data-accordion');

        stopTimeline();
        updateView($('.accordion-item[data-accordion='+item+']'));
    })

    return this.each(function () {
        var $this = $(this);
        var itemSelector = "." + options.itemClass;
        var items = $(itemSelector, $this);
        updateView(items.eq(options.start));

        $this.on('click', itemSelector + '>dt', function () {
            var activeItem = $(this).closest(itemSelector);
            if (activeItem.hasClass(options.activeClass)) {
                return;
            }

            stopTimeline();
            updateView(activeItem);
        });

    });

};

( function () {
    'use strict';

    buttonRipple();

    formValidation();

    stickyMenu();
    responsiveMenu();
    removeMenu();

    searchForm();
    backTop();
    faqScrollSpy();
    eventsCarousel();
    initBlogTableOfContents();

    contactForm();

    // Focus input if Searchform is empty
    [].forEach.call(document.querySelectorAll('.search-form'), ( el ) => {
        el.addEventListener('submit', function ( e ) {
            var search = el.querySelector('input');
            if ( search.value.length < 1 ) {
                e.preventDefault();
                search.focus();
            }
        });
    });

    // Initialize Popovers: https://getbootstrap.com/docs/5.0/components/popovers open modal function
    var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
    var popoverList = popoverTriggerList.map(function ( popoverTriggerEl ) {
        return new bootstrap.Popover(popoverTriggerEl, {
            trigger: 'focus',
        });
    });
    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
    const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))

    steps();
    initLandingFormCheckboxToggle();
} )();

function initBlogTableOfContents()
{
    document.querySelectorAll('.js-blog-toc').forEach(function (toc) {
        var header = toc.querySelector('.blog-toc__header');
        var toggle = toc.querySelector('.blog-toc__toggle');
        var links = Array.prototype.slice.call(toc.querySelectorAll('.blog-toc__link'));

        if (!header || !toggle || !links.length) {
            return;
        }

        var setActiveLink = function (activeLink) {
            links.forEach(function (link) {
                var isActive = link === activeLink;
                link.classList.toggle('is-active', isActive);

                if (isActive) {
                    link.setAttribute('aria-current', 'location');
                } else {
                    link.removeAttribute('aria-current');
                }
            });
        };

        header.addEventListener('click', function () {
            var isExpanded = toggle.getAttribute('aria-expanded') === 'true';
            toggle.setAttribute('aria-expanded', String(!isExpanded));
            toc.classList.toggle('is-collapsed', isExpanded);
        });

        links.forEach(function (link, index) {
            if (index === 0) {
                setActiveLink(link);
            }

            link.addEventListener('click', function () {
                setActiveLink(link);

                if (toc.classList.contains('blog-toc--mobile')) {
                    toggle.setAttribute('aria-expanded', 'false');
                    toc.classList.add('is-collapsed');
                }
            });
        });

        if (!('IntersectionObserver' in window)) {
            return;
        }

        var observedHeadings = links.map(function (link) {
            return {
                heading: document.getElementById(link.getAttribute('href').slice(1)),
                link: link,
            };
        }).filter(function (item) {
            return item.heading;
        });

        var observer = new IntersectionObserver(function (entries) {
            var visibleEntry = entries.filter(function (entry) {
                return entry.isIntersecting;
            }).sort(function (a, b) {
                return a.boundingClientRect.top - b.boundingClientRect.top;
            })[0];

            if (!visibleEntry) {
                return;
            }

            var match = observedHeadings.find(function (item) {
                return item.heading === visibleEntry.target;
            });

            if (match) {
                setActiveLink(match.link);
            }
        }, {
            rootMargin: '-20% 0px -65% 0px',
            threshold: 0,
        });

        observedHeadings.forEach(function (item) {
            observer.observe(item.heading);
        });
    });
}

// Set the options globally
// to make LazyLoad self-initialize
window.lazyLoadOptions = {
    // Your custom settings go here
};
// Listen to the initialization event
// and get the instance of LazyLoad
window.addEventListener(
    "LazyLoad::Initialized",
    function (event) {
        window.lazyLoadInstance = event.detail.instance;
    },
    false
);

function buttonRipple()
{
    let className, ripple;

    className = 'btn';
    ripple = document.createElement("span")
    ripple.classList.add('ripple')

    document.addEventListener('click', function (e) {
        if (e.target.classList.contains(className)) {
            ripple.setAttribute("style", "top: " + e.offsetY + "px; left: " + e.offsetX + "px");
            e.target.appendChild(ripple)
        }
    })
}

function removeMenu(){


        $(window).scroll(function() {
            $('.mega-menu-wrapper').each(function() {
                var $this = $(this);

                if ($this.css('opacity') == 1) {
                    $this.addClass('remove');
                }else{
                    $this.removeClass('remove');
                }
            });
        });


}
function formValidation()
{
    // Fetch all the forms we want to apply custom Bootstrap validation styles to
    const forms = document.querySelectorAll('.needs-validation')

    // Loop over them and prevent submission
    Array.from(forms).forEach(form => {
        form.addEventListener('submit', event => {
            if (!form.checkValidity()) {
                event.preventDefault()
                event.stopPropagation()
            }

            form.classList.add('was-validated')
        }, false)
    })
}

// Header
function stickyMenu()
{
    let value = window.outerWidth <= breakpoints.lg ? 400 : 600
    window.onscroll = function () {
        const header = document.getElementById("header");
        if (window.pageYOffset > value) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    };
}

function responsiveMenu()
{
    const navbarMain = $('#navbar_main')
    const navbarSecondary = $('#navbar-secondary')
    const navMobile = $('#nav-mobile')

    const primaryMenu = $('#menu-main-menu')
    const secondaryMenu = $('#menu-secondary-menu')
    const langMenu = $('.menu-lang');

    const searchButton = $('#search_btn')

    function dropdownMenu()
    {
        navMobile.find('.nav-item > .bi').on('click', function (e) {
            e.preventDefault();
            $(this).toggleClass('bi-chevron-up')
            $(this).toggleClass('bi-chevron-down')
            $(this).siblings('ul.sub-menu-list').toggleClass('show');
        })
    }

    function moveToMobile()
    {
        secondaryMenu.prependTo(navMobile);
        primaryMenu.prependTo(navMobile);
        dropdownMenu();

        langMenu.find('.dropdown-menu').removeClass('dropdown-menu-end');

        langMenu.appendTo(navMobile.find('.nav-footer'))
        searchButton.appendTo(navMobile.find('.nav-footer'))
        searchButton.addClass('btn-sm')

        $('#menu-main-menu .nav-item.mega-menu-parent').each(function () {
            const menu = $(this).find('.mega-menu-wrapper .sub-menu-list')
            const parent = $(this)

            menu.appendTo(parent)
        })
    }

    function moveToDesktop()
    {
        primaryMenu.appendTo(navbarMain);
        searchButton.appendTo(navbarMain);
        searchButton.removeClass('btn-sm')

        secondaryMenu.prependTo(navbarSecondary);

        langMenu.appendTo($('.site-menu .col-md-12'))

        $('.site-menu .menu-lang .dropdown-menu').addClass('dropdown-menu-end');

        $('#menu-main-menu .nav-item.mega-menu-parent').each(function () {
            const menu = $(this).find('.sub-menu-list')
            const parent = $(this).find('.mega-menu-wrapper .col-sub-menu')

            menu.appendTo(parent)
        })
    }

    $(window).on('load resize', function () {
        if (window.innerWidth <= breakpoints.lg) moveToMobile()
        else if (window.innerWidth > breakpoints.lg) {
            moveToDesktop()
        }
    })

    // mobile menu
    $('.header_top .navbar-toggler').on('click', function () {

        navMobile.toggleClass('show');
        $(this).find('.bi').toggleClass('bi-x-lg')
        if (!$(this).hasClass('bi-x-lg')) {
            navMobile.find('.nav-item').each(function () {
                $(this).find('.bi').removeClass('bi-chevron-up').addClass('bi-chevron-down');
                $(this).find('.sub-menu-list').removeClass('show');
            })
        }
    })

    $(window).on("scroll", function () {
        if ($(window).scrollTop() > 150) {
            $("header").addClass("sticky");
            $("body").addClass("menu-stuck");
        } else {
            $("header").removeClass("sticky");
            $("body").removeClass("menu-stuck");
        }
    });
}

function searchForm()
{
    //open
    $('#search_btn').on('click', function () {
        $('#searchNav').addClass('show');
    })

    //close
    $('#close_search').on('click', function () {
        $('#searchNav').removeClass('show');
    })

    function iconChange(elem)
    {
        if (elem.val().length > 0) {
            elem.siblings('.bi').removeClass('bi-search').addClass('bi-arrow-right').removeAttr('disabled')
        } else {
            elem.siblings('.bi').addClass('bi-search').removeClass('bi-arrow-right').attr('disabled', true)
        }
    }

    //input icon change
    $('#search_input').on('keyup', function (e) {
        iconChange($(this))
    })

    // fill suggestions
    $('.suggestion_item').on('click', function () {
        let text = $(this).text()
        $('#search_input').val(text);
        iconChange($('#search_input'))
    })
}


// Footer
function backTop()
{
    var footerBackTop = document.getElementById('footer-back-top');
    footerBackTop.addEventListener('click', function (e) {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
            });
    })
}

// FAQ

function faqScrollSpy()
{
    if (document.querySelector('.faq')) {
        var body = document.querySelector('body');
        body.setAttribute('data-bs-spy', 'scroll');
        body.setAttribute('data-bs-target', '#navbar-faq');
        body.setAttribute('data-bs-offset', '0');
    }
}

function contactForm()
{
    //or landing-form
    if (document.querySelector('.contact-form') || document.querySelector('.landing-form')) {
        var forms = document.querySelectorAll('.needs-validation')

        Array.prototype.slice.call(forms)
            .forEach(function (form) {
                form.addEventListener('submit', function (event) {

                    if (!form.checkValidity()) {
                        event.preventDefault()
                        event.stopPropagation()
                    }else {
                        const submitButton = form.querySelector('[type="submit"][data-sitekey]');
                        if(submitButton){
                            form.classList.remove('was-validated')
                        }

                    }

                    form.classList.add('was-validated')
                }, false)
                var submitButton = form.querySelector('[type="submit"]');
                var hasGkey = submitButton.hasAttribute('data-sitekey');
                console.log('hasGkey', hasGkey);
                if(hasGkey) {
                    if (submitButton) {
                        submitButton.addEventListener('click', function (event) {
                            var response = grecaptcha.getResponse();
                            console.log(response, 'response');
                            if (!form.checkValidity()) {

                                event.preventDefault();
                                form.dispatchEvent(new Event('submit'));
                                event.stopImmediatePropagation();
                            }else {
                                event.preventDefault();

                                if(!response){
                                    event.preventDefault();
                                    form.dispatchEvent(new Event('submit'));
                                    event.stopImmediatePropagation();
                                }else{
                                    event.preventDefault();
                                    if (typeof onSubmit === 'function') {
                                        document.getElementById('captcha').value = response;
                                        onSubmit(response);
                                    }
                                }

                            }

                        });
                    }
                }

            });
        const input = document.querySelector('#tel');
        let getCountryLang = input?.getAttribute("lang") || "en";



        const countryCode = getCountryLang === 'en' ? 'gb' : getCountryLang;
        console.log('country-code', countryCode)


        //input.insertAdjacentHTML('afterend', `<div class="invalid-feedback">`+pll__('required')+`</div>`);

        // Drag n Drop
        function formatBytes(a,b=2)
        {
            if (!+a) {
                return"0 Bytes";
            }const c=0>b?0:b,d=Math.floor(Math.log(a)/Math.log(1024));return`${parseFloat((a/Math.pow(1024,d)).toFixed(c))} ${["Bytes","KB","MB","GB","TB","PB","EB","ZB","YB"][d]}`}

        const preventDefaults = event => {
            event.preventDefault();
            event.stopPropagation();
        };

        const highlight = event =>
            event.target.classList.add('highlight');

        const unhighlight = event =>
            event.target.classList.remove('highlight');

        const getInputAndGalleryRefs = element => {
            const zone = element.closest('.upload_dropZone') || false;
            const gallery = zone.querySelector('.upload_gallery') || false;
            const input = zone.querySelector('input[type="file"]') || false;
            return {input: input, gallery: gallery};
        }

        const handleDrop = event => {
            const dataRefs = getInputAndGalleryRefs(event.target);
            dataRefs.files = event.dataTransfer.files;

            let fileInput = document.querySelector('#upload_image_background');

            const data = new DataTransfer();
            data.items.add(dataRefs.files[0]);
            fileInput.files = data.files;

            handleFiles(dataRefs);
        }

        const eventHandlers = zone => {
            const dataRefs = getInputAndGalleryRefs(zone);
            if (!dataRefs.input) {
                return;
            }

            // Prevent default drag behaviors
            ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(event => {
                zone.addEventListener(event, preventDefaults, false);
                document.body.addEventListener(event, preventDefaults, false);
            });

            // Highlighting drop area when item is dragged over it
            ['dragenter', 'dragover'].forEach(event => {
                zone.addEventListener(event, highlight, false);
            });

            ['dragleave', 'drop'].forEach(event => {
                zone.addEventListener(event, unhighlight, false);
            });

            // Handle dropped files
            zone.addEventListener('drop', handleDrop, false);

            // Handle browse selected files
            dataRefs.input.addEventListener('change', event => {
                dataRefs.files = event.target.files;
                handleFiles(dataRefs);
            }, false);
        }

        // Dropzones
        const dropZones = document.querySelectorAll('.upload_dropZone');
        for (const zone of dropZones) {
            eventHandlers(zone);
        }
        const isCorrectFile = file =>
            ['image/jpeg', 'image/png', 'application/pdf', 'application/msword'].includes(file.type);


        const removeFile = (event) => {
            event.preventDefault();
            event.stopPropagation();

            const removeBtn = document.querySelector('#upload_fileList_item_remove');
            removeBtn.removeEventListener('click', removeFile)

            const fileInput = document.querySelector('#upload_image_background');
            fileInput.value = null;

            const fileList = document.querySelector('#upload_fileList');
            fileList.innerHTML = '';
        }

        // Handle both selected and dropped files
        const handleFiles = dataRefs => {
            let isValidFile = true;
            let files = [...dataRefs.files];
            const invalidFeedback = document.querySelector('#upload_fileList_invalid');

            // Remove unaccepted file types
            files = files.filter(item => {
                let fileSize = item.size / 10240 / 10240; // in MiB

                if (!isCorrectFile(item)) {
                    console.log('File type not supported, ', item.type);
                    isValidFile = false;
                    invalidFeedback.innerHTML = 'File type not supported';
                    invalidFeedback.style.display = 'block';
                } else if (fileSize > 2) {
                    console.log('File is too big, ', item.size);
                    isValidFile = false;
                    invalidFeedback.innerHTML = 'File is too big';
                    invalidFeedback.style.display = 'block';
                } else {
                    invalidFeedback.innerHTML = '';
                    invalidFeedback.style.display = 'none';
                }

                return isValidFile ? item : null;
            });

        if (!files.length) {
            return;
        }
            dataRefs.files = files;

            let fileList = document.querySelector('#upload_fileList');
            fileList.innerHTML = '';

        for (const file of dataRefs.files) {
            let uploadItem = document.createElement('div');
            uploadItem.className = 'upload_fileList_item';
            uploadItem.insertAdjacentHTML("afterbegin", `
                <div>
                    <span class="bi bi-file-earmark-text ms-1"></span>
                    <span class="description">${file.name} </span>
                    <small class="caption">(${formatBytes(file.size)})</small>
                    </div>
                    <div>
                        <a href="#" id="upload_fileList_item_remove"><span class="bi bi-trash"></span> <span>Elimina</span></a>
                    </div>`);
                fileList.appendChild(uploadItem);

                const removeBtn = document.querySelector('#upload_fileList_item_remove');
                removeBtn.addEventListener('click', removeFile)
            }
        }

        // Select
        document.querySelectorAll('select').forEach(function (el) {
            el.addEventListener('change', function (e) {
                if (this.value !== '') {
                    this.classList.add('text-dark')
                }
            });
        })
}
}
function steps()
{

    if ($('.steps-block').length) {
        if (window.innerWidth > breakpoints.lg) {
            $(".steps-block dl.accordions").simpleAccordion();
        } else {
            $(".steps-block dl.accordions").children().wrapAll('<div class="carousel-inner"></div>');
            $(".steps-block dl.accordions").children().after('<div class="carousel-indicators"></div>');

            $('.steps-block dl.accordions .carousel-inner').children().each(function (index) {
                var indicatorClass = index === 0 ? 'active' : '';
                $('.steps-block dl.accordions .carousel-indicators')
                .append('<button type="button" data-bs-target="#accordion-carousel" data-bs-slide-to="'+index+'" class="'+indicatorClass+'" aria-current="true" aria-label="Slide '+(index+1)+'"></button>')
            })

            $(".steps-block dl.accordions .accordion-item").addClass('carousel-item');
            $(".steps-block dl.accordions .accordion-item").first().addClass('active');

            $(".steps-block dl.accordions").addClass('carousel slide');
            $(".steps-block dl.accordions").attr('data-bs-ride', 'carousel');

            const carousel = new bootstrap.Carousel('.steps-block dl.accordions')
        }
    }
}
function initLandingFormCheckboxToggle() {
    if ($(".landing-form .form-check-label").length) {
        $(".landing-form .form-check-label a").on("click", function(event) {
            event.stopPropagation(); // Prevent the label from triggering the checkbox
        });

        $(".landing-form .form-check-label").on("click", function(event) {
            if ($(event.target).is("a")) {
                return; // Do nothing if the link is clicked
            }
            let checkbox = $(this).siblings(".form-check-input");
            checkbox.prop("checked", !checkbox.prop("checked")); // Toggle checkbox
        });
    }
}
function eventsCarousel()
{

    var wrapper = $('.block-wrapper-event');
    var eventCard = wrapper.find('.event-card');

    if (wrapper.length) {
        // check if is mobile
        if (window.innerWidth < breakpoints.lg) {
            eventCard.children().wrapAll('<div class="carousel-inner"></div>');
            eventCard.children().after('<div class="carousel-indicators"></div>');

            // generate indicators
            eventCard.find('.carousel-inner').children().each(function (index) {
                var indicatorClass = index === 0 ? 'active' : '';
                console.log(indicatorClass);
                eventCard.find('.carousel-indicators').append('<button type="button" data-bs-target="#event-card" data-bs-slide-to="'+index+'" class="'+indicatorClass+'" aria-current="true" aria-label="Slide '+(index+1)+'"></button>')
            })

            eventCard.find('.js-filterable').removeClass('active js-filterable col-lg-4').addClass('carousel-item');
            eventCard.find('.carousel-item').first().addClass('active');

            eventCard.addClass('carousel slide');
            eventCard.attr('data-bs-ride', 'carousel');

            const eventCarousel = new bootstrap.Carousel('.event-card')
        }
    }
}
